// extracted by mini-css-extract-plugin
export default {"link":"NavigationLink_link__dcftY","button":"NavigationLink_button__eJdZ9","letter":"NavigationLink_letter__1Ssid"};